import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { routerMiddleware } from 'react-router-redux';
import createHistory from 'history/createBrowserHistory';

import rootReducer from '../reducers';
import rootSaga from '../sagas';

const middlewares = [];

const history = createHistory();
const historyMiddleware = routerMiddleware(history);
middlewares.push(historyMiddleware);

const sagaMiddleware = createSagaMiddleware();
middlewares.push(sagaMiddleware);

if (process.env.REACT_APP_ENV === 'development') {
  const { createLogger } = require('redux-logger');

  const logger = createLogger({
    level: 'info',
    collapsed: true
  });

  middlewares.push(logger);
}

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const enhancer = composeEnhancers(applyMiddleware(...middlewares));

export default function configureStore(initialState = {}) {
  const store = createStore(rootReducer, initialState, enhancer);

  sagaMiddleware.run(rootSaga);

  return store;
}



// WEBPACK FOOTER //
// ./src/store/configureStore.js